package com.yogaaicoach.pages.workout.data.models

import com.yogaaicoach.common.network.serializers.UuidSerializer
import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@Serializable
data class GetFocusAreasResponse(
    val selected: List<FocusAreaDataNarrowed>,
    val all: List<FocusAreaDataNarrowed>,
)

@OptIn(ExperimentalUuidApi::class)
@Serializable
data class FocusAreaDataNarrowed(
    @Serializable(with = UuidSerializer::class) val guid: Uuid,
    val name: String,
    val focus: String,
    val benefits: String,
) {
    fun toUiFormat(): com.yogaaicoach.pages.workout.editWorkout.ui.FocusAreaDataNarrowed {
        return com.yogaaicoach.pages.workout.editWorkout.ui.FocusAreaDataNarrowed(
            guid = this.guid,
            title = this.name,
            description = this.focus,
            benefits = this.benefits,
        )
    }
}